/*
  RK: gedrag van de eigen winkelwagen-lade - vervangt de UpCart-app.

  WAT DIT BESTAND WEL DOET
  - het upsell-blok onderin: bijpassende producten ophalen, tonen, maat
    kiezen en toevoegen aan de wagen;
  - het kortingscodeveld;
  - de lade opnieuw inlezen nadat er iets aan de wagen verandert.

  WAT DIT BESTAND NIET DOET, EN WAAROM NIET
  - Open- en dichtschuiven, de toetsenbordval en het sluiten op Escape: dat
    doet assets/cart-drawer.js van Dawn al, en de koptekst en de koopknop
    hangen daaraan vast. Niet overdoen.
  - Aantal wijzigen en artikelen verwijderen: dat doet assets/cart.js van
    Dawn (CartItems / cart-remove-button). Die vervangt na elke wijziging de
    HELE .drawer__inner met een verse versie van de sectie cart-drawer. Dat
    is precies waarom de spaarbalk, de kortingsregels en het totaal in
    Liquid staan en niet in dit bestand: ze komen na elke plus/min vanzelf
    kloppend terug van de server, zonder dat hier iets hoeft te rekenen.
    Zet die berekening hier dus niet alsnog neer.
  - De korting zelf toekennen. De 10%/15% zijn gewone automatic discounts in
    Shopify; die rekent Shopify door. Wij laten alleen zien hoe ver je bent.

  DE PRIJZEN IN HET UPSELL-BLOK
  De aanbevelingen komen als JSON binnen, met bedragen in centen en zonder
  opmaak. Daarom staat hier een kleine formatter die het geldformaat van de
  winkel (shop.money_format, meegegeven vanuit Liquid) toepast - zo staat er
  overal in de winkel exact dezelfde notatie, ook bij een andere valuta of
  een ander scheidingsteken.

  ALLE TEKST KOMT UIT DE TAAL-EDITOR. Niets staat hier hardcoded: de losse
  teksten worden als data-attribuut vanuit snippets/cart-drawer.liquid
  meegegeven. Voeg hier dus nooit een zin toe, maar een sleutel.
*/
(() => {
  if (window.__rkCartDrawer) return;
  window.__rkCartDrawer = true;

  const SEL_ROOT = 'cart-drawer';

  function shopRoot() {
    const r = window.Shopify && window.Shopify.routes && window.Shopify.routes.root;
    return r || '/';
  }

  /* ----------------------------------------------------------
     Geld opmaken volgens het formaat van de winkel.
     ---------------------------------------------------------- */
  function formatMoney(cents, fmt) {
    const value = (Number(cents) || 0) / 100;

    function grouped(decimals, thousands, decimal) {
      const parts = value.toFixed(decimals).split('.');
      const int = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return decimals > 0 ? int + decimal + parts[1] : int;
    }

    if (!fmt) return grouped(2, '.', ',');

    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/g, (match, name) => {
      switch (name) {
        case 'amount':
          return grouped(2, ',', '.');
        case 'amount_no_decimals':
          return grouped(0, ',', '.');
        case 'amount_with_comma_separator':
          return grouped(2, '.', ',');
        case 'amount_no_decimals_with_comma_separator':
          return grouped(0, '.', ',');
        case 'amount_with_apostrophe_separator':
          return grouped(2, "'", '.');
        case 'amount_with_space_separator':
          return grouped(2, ' ', ',');
        case 'amount_no_decimals_with_space_separator':
          return grouped(0, ' ', ',');
        default:
          return match;
      }
    });
  }

  /* ----------------------------------------------------------
     De lade opnieuw inlezen van de server.

     Eén bron van waarheid: de sectie cart-drawer. We halen 'm op en zetten
     de binnenkant erin, net zoals Dawn dat zelf doet bij een plus/min. Zo
     kloppen spaarbalk, kortingen en totaal altijd, en hoeft hier niets te
     worden bijgehouden.
     ---------------------------------------------------------- */
  let refreshing = null;

  function refresh() {
    if (refreshing) return refreshing;

    const root = shopRoot();

    refreshing = fetch(`${root}?section_id=cart-drawer`, { credentials: 'same-origin' })
      .then((res) => res.text())
      .then((text) => {
        const doc = new DOMParser().parseFromString(text, 'text/html');
        const srcInner = doc.querySelector('.drawer__inner');
        const dstInner = document.querySelector(`${SEL_ROOT} .drawer__inner`);
        if (srcInner && dstInner) dstInner.innerHTML = srcInner.innerHTML;

        const srcDrawer = doc.querySelector(SEL_ROOT);
        const dstDrawer = document.querySelector(SEL_ROOT);
        if (srcDrawer && dstDrawer) {
          dstDrawer.classList.toggle('is-empty', srcDrawer.classList.contains('is-empty'));
        }
      })
      .then(() => fetch(`${shopRoot()}?section_id=cart-icon-bubble`, { credentials: 'same-origin' }))
      .then((res) => res.text())
      .then((text) => {
        /* Het aantal-bolletje in de koptekst hoort meteen mee te lopen,
           anders staat er 2 terwijl er 3 in de wagen liggen. */
        const bubble = document.getElementById('cart-icon-bubble');
        if (!bubble) return;
        const doc = new DOMParser().parseFromString(text, 'text/html');
        const src = doc.querySelector('.shopify-section') || doc.body;
        if (src) bubble.innerHTML = src.innerHTML;
      })
      .catch(() => {
        /* Stil falen: de lade blijft staan zoals hij stond. Een mislukte
           verversing mag nooit de knop onbruikbaar maken. */
      })
      .finally(() => {
        refreshing = null;
      });

    return refreshing;
  }

  /* ----------------------------------------------------------
     UPSELL
     ---------------------------------------------------------- */

  const ARROW_PREV =
    '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M15 6l-6 6 6 6" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  const ARROW_NEXT =
    '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M9 6l6 6-6 6" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  function buildCard(product, box) {
    const moneyFormat = box.dataset.rkMoneyFormat || '';
    const addLabel = box.dataset.rkAdd || 'Add';
    const soldOutLabel = box.dataset.rkSoldOut || '';

    const variants = (product.variants || []).filter((v) => v.available);
    if (!variants.length) return null;

    const card = document.createElement('div');
    card.className = 'rk-up__card';

    const media = document.createElement('a');
    media.className = 'rk-up__media';
    media.href = product.url;
    const img = document.createElement('img');
    img.loading = 'lazy';
    img.alt = '';
    const src = product.featured_image || (product.images && product.images[0]) || '';
    if (src) {
      /* Kleine variant opvragen: de tegel is 56px, dus 160px is ruim zat ook
         op een scherm met dubbele pixels. */
      img.src = String(src).replace(/(\.[a-z]+)(\?|$)/i, '_160x$1$2');
      img.srcset = `${String(src).replace(/(\.[a-z]+)(\?|$)/i, '_160x$1$2')} 1x, ${String(src).replace(
        /(\.[a-z]+)(\?|$)/i,
        '_320x$1$2'
      )} 2x`;
    }
    media.appendChild(img);

    const info = document.createElement('div');
    info.className = 'rk-up__info';

    const title = document.createElement('a');
    title.className = 'rk-up__title';
    title.href = product.url;
    title.textContent = product.title;

    const price = document.createElement('div');
    price.className = 'rk-up__price';
    price.textContent = formatMoney(variants[0].price, moneyFormat);

    const buy = document.createElement('div');
    buy.className = 'rk-up__buy';

    let select = null;
    if (variants.length > 1) {
      select = document.createElement('select');
      select.className = 'rk-up__select';
      select.setAttribute('aria-label', box.dataset.rkVariantLabel || '');
      variants.forEach((v) => {
        const opt = document.createElement('option');
        opt.value = String(v.id);
        opt.textContent = v.title;
        select.appendChild(opt);
      });
      select.addEventListener('change', () => {
        const v = variants.find((x) => String(x.id) === select.value);
        if (v) price.textContent = formatMoney(v.price, moneyFormat);
      });
      buy.appendChild(select);
    }

    const add = document.createElement('button');
    add.type = 'button';
    add.className = 'rk-up__add';
    add.textContent = addLabel;
    add.addEventListener('click', () => {
      const id = select ? select.value : String(variants[0].id);
      add.disabled = true;
      fetch(`${shopRoot()}cart/add.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] }),
      })
        .then((res) => res.json())
        .then((data) => {
          if (data && data.status && data.status !== 200) {
            add.textContent = soldOutLabel || addLabel;
            add.disabled = false;
            return;
          }
          /* refresh() vervangt de hele binnenkant van de lade, dus deze knop
             bestaat daarna niet meer - de disabled-stand hoeft niet terug. */
          return refresh();
        })
        .catch(() => {
          add.disabled = false;
        });
    });
    buy.appendChild(add);

    info.appendChild(title);
    info.appendChild(price);
    info.appendChild(buy);

    card.appendChild(media);
    card.appendChild(info);
    return card;
  }

  /* RK: de opgehaalde aanbevelingen per startproduct onthouden.

     Waarom dit moet: bij elke plus of min vervangt Dawn de HELE .drawer__inner,
     dus ook het upsell-blok. Zonder geheugen werd er elke keer opnieuw een
     verzoek gedaan en ploften de kaartjes een halve seconde later alsnog in
     beeld - een zichtbare sprong na iedere klik. Met dit geheugen staan ze er
     meteen, zonder netwerkverkeer. */
  const recoCache = Object.create(null);

  function fillUpsell(box, track, products) {
    let shown = 0;
    products.forEach((p) => {
      const card = buildCard(p, box);
      if (card) {
        track.appendChild(card);
        shown += 1;
      }
    });

    if (!shown) return;

    box.hidden = false;
    if (shown > 1) box.setAttribute('data-rk-many', '');

    const prev = box.querySelector('.rk-up__nav--prev');
    const next = box.querySelector('.rk-up__nav--next');
    if (prev) prev.innerHTML = ARROW_PREV;
    if (next) next.innerHTML = ARROW_NEXT;

    const step = () => track.clientWidth || 1;
    if (prev) prev.addEventListener('click', () => track.scrollBy({ left: -step(), behavior: 'smooth' }));
    if (next) next.addEventListener('click', () => track.scrollBy({ left: step(), behavior: 'smooth' }));
  }

  function initUpsell(box) {
    if (!box || box.hasAttribute('data-rk-up-ready')) return;
    box.setAttribute('data-rk-up-ready', '');

    const track = box.querySelector('[data-rk-up-track]');
    const seedId = box.dataset.rkSeed;
    const inCart = (box.dataset.rkInCart || '').split(',').filter(Boolean);
    if (!track || !seedId) return;

    const keep = (list) => list.filter((p) => inCart.indexOf(String(p.id)) === -1);

    /* Al eens opgehaald voor dit startproduct? Dan meteen neerzetten, zonder
       netwerk en dus zonder sprong. De filter op wat er al in de wagen ligt
       draait wél opnieuw - die lijst verandert immers per klik. */
    if (recoCache[seedId]) {
      fillUpsell(box, track, keep(recoCache[seedId]));
      return;
    }

    const url = `${shopRoot()}recommendations/products.json?product_id=${encodeURIComponent(
      seedId
    )}&limit=10&intent=related`;

    fetch(url, { credentials: 'same-origin' })
      .then((res) => res.json())
      .then((data) => {
        const all = data && data.products ? data.products : [];
        recoCache[seedId] = all;
        fillUpsell(box, track, keep(all));
      })
      .catch(() => {
        /* Stil falen: zonder aanbevelingen blijft het blok simpelweg verborgen. */
      });
  }

  /* ----------------------------------------------------------
     DE SCHUIFSTAND VASTHOUDEN

     Dawn vervangt bij elke plus/min de hele binnenkant van de lade. De
     schuifbak is daarna een VERS element en begint dus bovenaan. Stond je bij
     het derde artikel, dan sprong je na één klik op de plus terug naar het
     eerste - en dat voelt alsof de lade op hol slaat.
     We onthouden hoe ver er geschoven was en zetten dat na de verversing
     terug. Eén keer per verse kopie (vlag data-rk-scroll-ready), zodat we
     nooit tegen het scrollen van de bezoeker zelf in duwen.
     ---------------------------------------------------------- */
  let keptScrollTop = 0;

  function initScroll(box) {
    if (!box || box.hasAttribute('data-rk-scroll-ready')) return;
    box.setAttribute('data-rk-scroll-ready', '');

    if (keptScrollTop > 0 && box.scrollTop === 0) {
      /* Na de volgende tekenbeurt, anders is de hoogte nog niet bekend en
         knipt de browser onze waarde af tot 0. */
      window.requestAnimationFrame(() => {
        box.scrollTop = keptScrollTop;
      });
    }

    box.addEventListener(
      'scroll',
      () => {
        keptScrollTop = box.scrollTop;
      },
      { passive: true }
    );
  }

  /* ----------------------------------------------------------
     KORTINGSCODE

     De Cart AJAX API van Shopify kan géén kortingscode toepassen. De enige
     ondersteunde manier is /discount/<CODE> aanroepen; dat zet de code op de
     sessie. Met ?redirect=...cart.js komt er meteen de wagen als JSON terug
     in plaats van de hele homepage (anders haal je er 1,4 MB HTML doorheen
     voor één code).

     Of de code geldig is lezen we af aan discount_codes[].applicable in die
     JSON - niet aan de HTTP-status, want /discount/ geeft ook bij een
     onzinnige code gewoon een redirect.

     BEWUST GEEN KRUISJE OM DE CODE WEER WEG TE HALEN: Shopify heeft daar
     geen ondersteunde route voor. Een nepoplossing (een onzincode erover
     heen zetten) zou een foutmelding tonen en de klant in verwarring
     brengen. Een verkeerd ingevoerde code vervang je door simpelweg de
     juiste in te vullen, en in de checkout kan hij er alsnog uit.
     ---------------------------------------------------------- */
  function initDiscount(box) {
    if (!box || box.hasAttribute('data-rk-dc-ready')) return;
    box.setAttribute('data-rk-dc-ready', '');

    const input = box.querySelector('.rk-dc__input');
    const button = box.querySelector('.rk-dc__apply');
    const msg = box.querySelector('.rk-dc__msg');
    if (!input || !button) return;

    function show(text) {
      if (!msg) return;
      msg.textContent = text || '';
      msg.hidden = !text;
    }

    function apply() {
      const code = (input.value || '').trim();
      if (!code) return;

      show('');
      button.disabled = true;

      const root = shopRoot();
      const back = encodeURIComponent(`${root}cart.js`);

      fetch(`${root}discount/${encodeURIComponent(code)}?redirect=${back}`, {
        credentials: 'same-origin',
        cache: 'no-store',
      })
        .then((res) => res.json())
        .catch(() =>
          /* Mocht de redirect niet gevolgd worden, dan halen we de wagen
             gewoon los op. */
          fetch(`${shopRoot()}cart.js`, { credentials: 'same-origin', cache: 'no-store' }).then((r) => r.json())
        )
        .then((cart) => {
          const codes = (cart && cart.discount_codes) || [];
          const hit = codes.find((d) => String(d.code).toLowerCase() === code.toLowerCase());

          if (!hit || hit.applicable === false) {
            show(box.dataset.rkInvalid || '');
            button.disabled = false;
            return;
          }

          return refresh();
        })
        .catch(() => {
          show(box.dataset.rkInvalid || '');
          button.disabled = false;
        });
    }

    button.addEventListener('click', apply);
    input.addEventListener('keydown', (e) => {
      if (e.key === 'Enter') {
        e.preventDefault();
        apply();
      }
    });
  }

  /* ----------------------------------------------------------
     AANHAKEN - ook na elke verversing

     Dawn vervangt bij elke plus/min de complete .drawer__inner, dus de
     elementen waar we hierboven aan hangen zijn daarna weg. Een waarnemer op
     de lade hangt ze opnieuw aan. De vlaggen data-rk-up-ready /
     data-rk-dc-ready zorgen dat dat precies één keer per verse kopie
     gebeurt, dus de waarnemer kan niet op zijn eigen wijziging blijven
     reageren.
     ---------------------------------------------------------- */
  function wire() {
    document.querySelectorAll('.rk-cart__scroll').forEach(initScroll);
    document.querySelectorAll('[data-rk-upsell]').forEach(initUpsell);
    document.querySelectorAll('[data-rk-discount]').forEach(initDiscount);
  }

  function throttled(fn) {
    let id = 0;
    return function () {
      if (id) return;
      id = window.requestAnimationFrame(() => {
        id = 0;
        fn();
      });
    };
  }

  function start() {
    wire();

    const drawer = document.querySelector(SEL_ROOT);
    if (drawer && window.MutationObserver) {
      new MutationObserver(throttled(wire)).observe(drawer, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
